module.exports = __webpack_public_path__ + "img/thank_you_bg.cad17aea.png";